export default __webpack_public_path__ + "static/media/14@2x.b50b9a19.webp";